import React from "react";

import {
  modal,
  closeButton,
} from "./pop-up.module.scss";

const Popup = ({ onClose }) => (
  <div className={modal}>
    <div className="absolute">
      <h2 className="text-lg font-bold">EINLADUNG ZUM VORTRAG</h2>
      <br />
      <p><strong>JUSt married – Partnerschaft und Recht</strong></p>
      <br />
      <p>Eintritt frei</p>
      <br />
      <p>Wann: <strong>07.05.2025 um 18:30 Uhr</strong></p>
      <p>Wo: <strong><a style={{ textDecoration: 'none' }} href="https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=/maps/place//data%3D!4m2!3m1!1s0x479b38d76512c86b:0xe2bfaafdf82f9010%3Fsa%3DX%26ved%3D1t:8290%26ictx%3D111&ved=2ahUKEwjggJT_lsmMAxW1FhAIHUMWHhIQ4kB6BAg9EAM&usg=AOvVaw0ZQMrFYzRP0ieqwm93NsiL/" target="_blank" rel="noopener noreferrer">Vinomnasaal Rankweil</a></strong></p>
      <p>Referent: <strong><a style={{ textDecoration: 'none' }} href="https://rawelte.at/martin-doerler/" target="_blank" rel="noopener noreferrer">RA Dr. Martin Dörler</a></strong></p>
      <p>Programm: <strong>Praxisnaher Vortrag mit Bewirtung und musikalischer Begleitung</strong></p>
      <br />
      <p>
        Rechtsanwalt Dr. Martin Dörler gibt einen Überblick über die wichtigsten rechtlichen
        Unterschiede zwischen Ehe und Lebensgemeinschaft. Er erklärt, welche Regelungen
        für gemeinsame Anschaffungen, Eigentum, Erbrecht und Kinder gelten und zeigt auf,
        welche Vorsorge getroffen werden kann. Besonderes Augenmerk liegt auf der Absicherung beider 
        Partner – insbesondere bei Trennung, Krankheit oder Todesfall.
      </p>
      <br />
      <p>
        <strong>
          <a style={{ textDecoration: 'none' }} href="https://rawelte.fra1.cdn.digitaloceanspaces.com/files/Einladung%20Vortrag%20JUSt%20married.pdf" target="_blank" rel="noopener noreferrer">
            Mehr Informationen zum Vortrag
          </a>
        </strong>
      </p>
      <br />
      <br />
      <p>Anmeldung unter <a style={{ textDecoration: 'none' }} href="mailto:kanzlei@rawelte.at">kanzlei@rawelte.at</a> gewünscht!</p>
      <br />
      <button 
        className={closeButton} 
        onClick={onClose}
      >
        Schließen
      </button>
    </div>
  </div>
);

export default Popup;
